export enum MessageType {
  ASSISTANT = 'ASSISTANT',
  USER = 'USER',
}
export interface IMessage {
  text: string;
  type: MessageType;
  timestamp: number;
}

export enum EAudioPlaybackType {
  VOICE_COMMAND = 'VOICE_COMMAND',
  AUDIO_ZONE = 'AUDIO_ZONE',
  GREETINGS = 'GREETINGS',
  CHAT = 'CHAT',
}

export enum SCREENS {
  DEFAULT = 'DEFAULT',
  HOW_TO = 'HOW_TO',
  CHAT = 'CHAT',
  TELEPORT = 'TELEPORT',
}

export enum AWAITING_RESPONSE_TYPE {
  NONE = '',
  SHORT = 'SHORT',
  LONG = 'LONG',
}
